const daysTillOtherDate = (endDate) => {
  const today = new Date()

  return Math.ceil((endDate - today) / (1000 * 60 * 60 * 24))
}

export default daysTillOtherDate
